import { TOS_VERSION } from '@/config/tos-version';
import { captureError } from '@/lib/sentry';
import { debug } from '@/lib/debug';

const SESSION_KEY = 'dextoro_consent_session';

// Must match the consent paragraph in HowItWorksModal.tsx exactly
const CONSENT_TEXT =
  'By clicking this button, you agree to the terms and conditions and certify that you are over 18 years old.';

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

/**
 * Fire-and-forget server-side consent audit log.
 * Failures are captured in Sentry but never propagated to the caller.
 */
export async function logConsent(walletAddress: string | null): Promise<void> {
  try {
    const payload = {
      tos_version: TOS_VERSION,
      consent_text: CONSENT_TEXT,
      session_id: getSessionId(),
      screen_resolution: `${screen.width}x${screen.height}`,
      viewport_size: `${innerWidth}x${innerHeight}`,
      referrer_url: document.referrer,
      wallet_address: walletAddress || undefined,
    };

    debug.trace('[Consent] Logging consent event', payload);

    const url = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/log-consent`;

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const body = await res.text();
      throw new Error(`Consent log failed: ${res.status} ${body}`);
    }

    debug.trace('[Consent] Consent event recorded successfully');
  } catch (err) {
    captureError(err instanceof Error ? err : new Error(String(err)), {
      context: 'consent-logger',
    });
    debug.trace('[Consent] Failed to log consent event', err);
  }
}
